import React, { useState, useEffect } from 'react';
import { lambdaURL } from '../config';
import { sendRequest } from './vmUtils';

export const VMTopicSelector = ({ setName }) => {
  const [uniqueTopics, setUniqueTopics] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchTopics = async () => {
      try {
        const response = await sendRequest(lambdaURL, {
          command: "getAllPublicTopics"
        });

        if (response.body) {
          const topics = JSON.parse(response.body);
          // Get unique topic names using Set
          const uniqueNames = Array.from(new Set(
            topics
              .map(topic => topic.name)
              .filter(name => name && name !== "No Topic")
          )).sort((a, b) => a.localeCompare(b)); // Sort alphabetically

          setUniqueTopics(uniqueNames);
        }
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching topics:', error);
        setIsLoading(false);
      }
    };

    fetchTopics();
  }, []);

  if (isLoading) {
    return null;
  }

  return (
    <div className="mb-4">
      <select 
        className="w-full p-2 border rounded bg-white"
        onChange={(e) => setName(e.target.value)}
      >
        <option value="">-- Select Existing Topic Name --</option>
        {uniqueTopics.map((name) => (
          <option key={name} value={name}>
            {name}
          </option>
        ))}
      </select>
    </div>
  );
};

//export default TopicNameSelector;